<template>
    <div>
        <div v-if="alertVisibility"  class="request-alert">
            <div class="request-alert-content">
                <Icon icon="i"/>
                <div v-if="updateDateState.updateDate.upcoming">
                    <p>You have a Crossprom with this campaign</p>
                    <p @click="showPostModal">Preview Update</p>
                </div>
                <div v-else>
                    <p>You have Crosspromed with this campaign.</p>
                    <p @click="checkUpdate">Check update</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import useCpRequestAlert from './useCpRequestAlert'
import { useRouter, useStore } from '../../core/hooks'
import { computed } from '@vue/composition-api'
import { objectBuilder } from '../../core/utils'
export default {
    name: 'CpRequestAlert',
    components: {
        Icon,
    },
    setup(props, context) {
        const { store } = useStore()
        const { updateDateState } = useCpRequestAlert()
        const { router, route } = useRouter()
        const alertVisibility = computed(() => updateDateState.updateDate && !updateDateState.loading)
        
        const showPostModal = () => {
            store.commit('TOGGLE_MODAL', ['sharable-content', objectBuilder.getUpdateInfo(updateDateState.updateDate)])
            const campaign = updateDateState.updateDate.spots.find(item => item && item.cpid === route.value.params.campaignID)
            context.root.$ga.event('Crossprom Info', 'Preview Update Button Click', `
                Campaign: ${campaign.cname},
                Location: Campaign Page
            `);

            context.root.$sendMixpanelEvent('Preview Update Button Clicked', {
                'Campaign Name': campaign.cname,
                'Button Location': 'Campaign Page'
            });
        }

        const checkUpdate = () => {
            const data = updateDateState.updateDate
            const campaign = updateDateState.updateDate.spots.find(item => item && item.cpid === route.value.params.campaignID)
            context.root.$ga.event('Campaign', 'Alert Check Update Button Click', 'Campaign', campaign.cname);
            context.root.$sendMixpanelEvent('Check Update Button Clicked', {
                'Campaign Name': campaign.cname
            });
            router.push({
                path: `/dashboard/updates`,
                query: {
                    type: 'scheduled',
                    page: undefined,
                    filters: undefined,
                    id: data.id
                }
            }).catch(() => {})
        }

        return {
            alertVisibility,
            checkUpdate,
            showPostModal,
            updateDateState
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
div.request-alert {
    height: 60px;
    border-top: 4px solid $c1;
    background: $c24;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
        margin: 0 !important;
    }
    div.request-alert-content {
        display: flex;
        align-items: center;
        div {
            display: flex;
            margin-left: 16px;
            p,a {
                font-size: 16px;
                font-weight: $weight_bold;
            }
            p {
                &:first-child {
                    color: $c6;
                }
                &:last-child {
                    color: $c1;
                    margin-left: 8px !important;
                    cursor: pointer;
                }
            }
            a {
                color: $c1;
                margin-left: 8px !important;
                cursor: pointer;
            }
        }
    }
}
</style>
